module.exports = __webpack_public_path__ + "static/desktop/img/group-empty.39714928.svg";